module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/257-sardinia-0f03b648009028e4cf1adade2afa9cb3.svg";